import localStorageService from '../services/localStorageService';
import OrganizationConfigurationsServices from '../services/OrganizationConfigurationsServices';

/**
 * Persist session user for legacy views that read from localStorage.
 * Tokens stay in HttpOnly cookies / session — do not store access_token here.
 */
export function persistUserSession(user, organization_id) {
    if (!user) {
        return;
    }

    const employeeId = user.userId || user.id || user.employee?.id;
    const orgId = organization_id || user.employee?.organization_id || null;

    const sessionUser = {
        ...user,
        id: employeeId || user.id,
        userId: employeeId || user.userId || user.id,
    };

    localStorageService.setItem('user', sessionUser);

    if (employeeId) {
        localStorage.setItem('user_id', String(employeeId));
    }

    if (orgId) {
        localStorage.setItem('organization_id', String(orgId));
    }
}

export function clearLegacyTokenStorage() {
    localStorageService.removeItem('access_token');
    localStorageService.removeItem('refresh_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
}

export function clearAuthSessionStorage() {
    clearLegacyTokenStorage();
    localStorageService.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('organization_id');
    localStorage.removeItem('organization_config');
}

export function resolveCurrentUserId(userFromRedux) {
    if (userFromRedux) {
        return userFromRedux.userId || userFromRedux.id || userFromRedux.employee?.id || '';
    }
    const storedUser = localStorageService.getItem('user');
    if (storedUser) {
        return storedUser.userId || storedUser.id || storedUser.employee?.id || '';
    }
    return localStorage.getItem('user_id') || '';
}

export function resolveOrganizationId(userFromRedux) {
    if (userFromRedux?.employee?.organization_id) {
        return userFromRedux.employee.organization_id;
    }
    return localStorage.getItem('organization_id') || '';
}

export async function prefetchOrganizationConfig(organization_id) {
    const orgId = organization_id || localStorage.getItem('organization_id');
    if (!orgId) {
        return;
    }

    try {
        const [hierarchyResponse, managerResponse] = await Promise.all([
            OrganizationConfigurationsServices.getAll({
                organization_id: orgId,
                type: 'ASSIGNMENT_HIERARCHY',
                key: 'hierarchy_levels',
            }),
            OrganizationConfigurationsServices.getAll({
                organization_id: orgId,
                type: 'ASSIGNMENT_HIERARCHY',
                key: 'manager_levels',
            }),
        ]);

        localStorage.setItem(
            'organization_config',
            JSON.stringify({
                hierarchy_levels: hierarchyResponse,
                manager_levels: managerResponse,
            })
        );
    } catch (error) {
        console.warn('Failed to prefetch organization config:', error?.message || error);
    }
}
